export default{
  carousels:[
    {
      id: 0,
      title: '',
      text: 'Patent dla Janusza Bohdanowicza wydany przez Kierownika Urzędu ds. Kombatantów i Osób Represjonowanych oraz Prezesa Rady Ministrów Rzeczypospolitej Polskiej w 1999 roku.',
      img: "/o_autorze/o_autorze_1.jpg"
    },
    {
      id: 1,
      title: '',
      text: 'Podziękowanie dla Janusza Bohdanowicza od Leszka Pałasza, Starosty Bytowskiego za organizację konkursu „Armia Krajowa w Okręgu Wileńskim” z 21 stycznia 2002 roku.',
      img: "/o_autorze/o_autorze_2.jpg"
    },
    {
      id: 2,
      title: '',
      text: 'Podziękowanie dla Janusza Bohdanowicza za przygotowanie wystawy fotograficznej na uroczystość poświęcenia sztandaru od Komitetu Fundacji Sztandaru Okręgu Nowogródzkiego Armii Krajowej.',
      img: "/o_autorze/o_autorze_3.jpg"
    },
    {
      id: 3,
      title: '',
      text: 'Arkusz weryfikacyjny do zaświadczenia o służbie Janusza Bohdanowicza w 7. Brygadzie „Wilhelma” Armii Krajowej.',
      img: "/o_autorze/o_autorze_4.jpg"
    },
    {
      id: 4,
      title: '',
      text: 'Uzasadnienie nadania Januszowi Bohdanowiczowi ps. „Czortek” odznaczenia Krzyża Walecznych.',
      img: "/o_autorze/o_autorze_5.jpg"
    },
    {
      id: 5,
      title: '',
      text: 'Artykuł pt. „My z 7. Wileńskiej Brygady AK” – wspomnienia Janusza Bohdanowicza ps. „Czortek”, opublikowane w 1990 roku.',
      img: "/o_autorze/o_autorze_6_7.jpg"
    },
    {
      id: 6,
      title: '',
      text: 'Artykuł Jerzego Surwiło pt. „Wyświęcenie cmentarza żołnierskiego 7. Brygady AK. Skorbuciany, 14 lipca 1991”, opublikowany w „Kurierze Wileńskim”.',
      img: "/o_autorze/o_autorze_8.jpg"
    },
    {
      id: 7,
      title: '',
      text: 'Artykuł pt. „Nasze wspólne dziedzictwo. W Koleśnikach na Jasnej Górze”, opublikowany w „Kurierze Wileńskim” z 13 lipca 1993 roku.',
      img: "/o_autorze/o_autorze_9.jpg"
    },
    {
      id: 8,
      title: '',
      text: 'Artykuł Krystyny Adamowicz pt. "Dobroczynność. Łańcuch gorących serc", opublikowany w „Kurierze Wileńskim” z 29 października 1994 roku.',
      img: "/o_autorze/o_autorze_10.jpg"
    },
    {
      id: 9,
      title: '',
      text: 'Artykuł pt. „Kolejna akcja dobroczynności. Pan Janusz Bohdanowicz znowu pomaga”, opublikowany w „Kurierze Wileńskim” z 22 kwietnia 1995 roku.',
      img: "/o_autorze/o_autorze_11.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/o_autorze.js